<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import type { RosterType } from '@interfaces/roster_type';
import type { StructureType } from '@interfaces/structure_type';
import LocaleSwitcher from '../../shared/LocaleSwitcher.vue';

export default defineComponent({
  name: 'Breadcrumbs',
  components: {
    LocaleSwitcher
  },
  props: {
    roster: {
      type: Object as PropType<RosterType>,
      required: true
    },
    structure: {
      type: Object as PropType<StructureType>,
      required: true
    },
    step: {
      type: String,
      required: true
    }
  },
  emits: ["select-step"],
  setup() {
    const i18n = useI18n();
    return {
      t: i18n.t
    };
  },
  methods: {
    selectStep(step) {
      this.$emit('select-step', step);
    }
  }
});
</script>

<template>
  <div class="breadcrumbs">
    <a href="#"
       class="breadcrumbs-item"
       :class="{'disabled': step != 'selectDomain'}"
       @click.prevent="selectStep('selectDomain')">
      {{ t('breadcrumbs.domain') }}
    </a>
    <a href="#"
       class="breadcrumbs-item"
       :class="{'disabled': step != 'selectFaction'}"
       @click.prevent="selectStep('selectFaction')"
       v-if="structure.faction || step == 'selectFaction'">
      {{ t('breadcrumbs.faction') }}
    </a>
    <a href="#"
       class="breadcrumbs-item"
       :class="{'disabled': step != 'selectHero'}"
       @click.prevent="selectStep('selectHero')"
       v-if="structure.hero || step == 'selectHero'">
      {{ t('breadcrumbs.leader') }}
    </a>
    <a href="#"
       class="breadcrumbs-item"
       :class="{'disabled': step != 'selectUnit'}"
       @click.prevent="selectStep('selectUnit')"
       v-if="structure.hero || step == 'selectUnit'">
      {{ t('breadcrumbs.units') }}
    </a>
  </div>

  <div class="header-actions">
    <redeem-button :mobile="false"></redeem-button>

    <share-button :roster="roster" :mobile="false"></share-button>

    <button class="header-action button button_plain button_icon" disabled>
      <img src="@/images/img/print.png" alt="">
    </button>

    <locale-switcher />
  </div>
</template>

<style scoped>
.header-action {
  font-weight: bold;
  min-width: 40px;
  font-size: 20pt;
  text-align: center;
}
</style>
